import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function AvailabilitiesIcon({ className }: IconProps) {
  return (
    <svg
      width="82"
      height="82"
      viewBox="0 0 82 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1203_1443)">
        <path
          d="M0 41C0 63.6425 18.3575 82 41 82C63.6425 82 82 63.6425 82 41C82 18.3575 63.6425 0 41 0C18.3575 0 0 18.3575 0 41Z"
          fill="#EAF0F3"
        />
        <path
          d="M3.60059 41.0001C3.60059 61.6395 20.3353 78.3996 41.0001 78.3996C61.6649 78.3996 78.3742 61.6649 78.3742 41.0001C78.3742 20.3353 61.6395 3.60059 41.0001 3.60059C20.3606 3.60059 3.60059 20.3606 3.60059 41.0001Z"
          fill="#00C4B3"
        />
        <path
          d="M8.31641 41C8.31641 42.1664 9.25456 43.1045 10.4209 43.1045C11.5873 43.1045 12.5254 42.1664 12.5254 41C12.5254 39.8337 11.5873 38.8955 10.4209 38.8955C9.25456 38.8955 8.31641 39.8337 8.31641 41Z"
          fill="white"
        />
        <path
          d="M69.4746 41C69.4746 42.1664 70.4128 43.1045 71.5791 43.1045C72.7455 43.1045 73.6836 42.1664 73.6836 41C73.6836 39.8337 72.7455 38.8955 71.5791 38.8955C70.4128 38.8955 69.4746 39.8337 69.4746 41Z"
          fill="white"
        />
        <path
          d="M12.6774 57.3542C13.2606 58.3684 14.5537 58.698 15.5679 58.1148C16.5821 57.5317 16.9118 56.2385 16.3539 55.2243C15.7708 54.2101 14.4776 53.8805 13.4634 54.4636C12.4492 55.0468 12.0942 56.3399 12.6774 57.3542Z"
          fill="white"
        />
        <path
          d="M65.6452 26.7502C66.2283 27.7644 67.5215 28.094 68.5357 27.5362C69.5499 26.953 69.8795 25.6599 69.3217 24.6457C68.7385 23.6315 67.4454 23.3018 66.4312 23.885C65.417 24.4682 65.062 25.7613 65.6452 26.7756"
          fill="white"
        />
        <path
          d="M24.6461 69.3222C25.6603 69.9053 26.9534 69.5504 27.5366 68.5615C28.1198 67.5473 27.7648 66.2541 26.7759 65.671C25.7617 65.0878 24.4686 65.4428 23.8854 66.4316C23.3022 67.4458 23.6572 68.739 24.6714 69.3222"
          fill="white"
        />
        <path
          d="M55.2242 16.329C56.2384 16.9122 57.5315 16.5572 58.1147 15.5683C58.6979 14.5541 58.3429 13.261 57.3541 12.6778C56.3398 12.0946 55.0467 12.4496 54.4635 13.4385C53.8803 14.4527 54.2353 15.7458 55.2495 16.329"
          fill="white"
        />
        <path
          d="M57.3293 69.3224C58.3435 68.7392 58.6732 67.446 58.1153 66.4318C57.5321 65.4176 56.239 65.088 55.2248 65.6712C54.2106 66.2543 53.8809 67.5475 54.4641 68.5617C55.0473 69.5759 56.3404 69.9055 57.3547 69.3224"
          fill="white"
        />
        <path
          d="M26.7502 16.3292C27.7644 15.746 28.094 14.4529 27.5362 13.4387C26.953 12.4244 25.6599 12.0948 24.6457 12.678C23.6315 13.2612 23.3018 14.5543 23.885 15.5685C24.4682 16.5827 25.7613 16.9124 26.7756 16.3292"
          fill="white"
        />
        <path
          d="M69.3217 57.3545C69.9049 56.3402 69.5499 55.0471 68.5357 54.4639C67.5215 53.8807 66.2537 54.2357 65.6452 55.2246C65.062 56.2388 65.417 57.5319 66.4312 58.1151C67.4454 58.6983 68.7132 58.3433 69.3217 57.3545Z"
          fill="white"
        />
        <path
          d="M16.3286 26.75C16.9117 25.7357 16.5568 24.4426 15.5425 23.8594C14.5283 23.2763 13.2605 23.6312 12.652 24.6201C12.0688 25.6343 12.4238 26.9275 13.438 27.5106C14.4522 28.0938 15.72 27.7388 16.3286 26.7246"
          fill="white"
        />
        <path
          d="M41 73.6831C42.1664 73.6831 43.1045 72.745 43.1045 71.5786C43.1045 70.4123 42.1664 69.4741 41 69.4741C39.8337 69.4741 38.8955 70.4123 38.8955 71.5786C38.8955 72.745 39.8337 73.6831 41 73.6831Z"
          fill="white"
        />
        <path
          d="M61.0313 42.8763H41.0003C39.9608 42.8763 39.124 42.0395 39.124 41V11.0296C39.124 9.99006 39.9608 9.15332 41.0003 9.15332C42.0399 9.15332 42.8767 9.99006 42.8767 11.0296V39.1236H61.0566C62.0962 39.1236 62.9329 39.9604 62.9329 41C62.9329 42.0395 62.0962 42.8763 61.0566 42.8763"
          fill="#00416B"
        />
        <path
          d="M35.3965 41.0001C35.3965 44.0935 37.9067 46.6037 41.0001 46.6037C44.0935 46.6037 46.6037 44.0935 46.6037 41.0001C46.6037 37.9067 44.0935 35.3965 41.0001 35.3965C37.9067 35.3965 35.3965 37.9067 35.3965 41.0001Z"
          fill="#FBFCFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_1203_1443">
          <rect width="82" height="82" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
